"use strict";

require("./index.scss");
require("tippy.js/dist/tippy.css");
require("tippy.js/themes/light.css");